import { render, staticRenderFns } from "./modalEditTenantTournament.vue?vue&type=template&id=7cbe31a7&"
import script from "./modalEditTenantTournament.vue?vue&type=script&lang=js&"
export * from "./modalEditTenantTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports